import type { ElementType } from 'react';

import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router';

import BreadcrumbContent from '../BreadcrumbContent';

export interface BreadcrumbLinkProps {
  label: string;
  path: string;
  icon?: ElementType;
}

const BreadcrumbLink = ({ label, path, icon }: BreadcrumbLinkProps) => (
  <Link
    component={RouterLink}
    to={path}
    underline="hover"
    color="inherit"
    sx={{ display: 'inline-flex', alignItems: 'center' }}
  >
    <BreadcrumbContent label={label} icon={icon} />
  </Link>
);

export default BreadcrumbLink;
